<div *ngIf="activeRoute !== '/lock' && activeRoute !== '/login'" class="dialog-container">
  <img
    (click)="cancel()"
    [src]="images.CLOSE_TRANSPARENT"
    class="cross-transparent"
    [alt]="'CLOSE' | fallbackTranslate"
  />
  <img class="drip" [src]="data?.image" alt="drip" />
</div>
